import { themeVars as platformThemeConstants } from '../../../pdc-platform/src/ts/themes/themeConstants';

export const name: string = 'Workspace Container';
export const group = 'Layout';
export const moduleName: string = 'pdc-widget-workspace';
export const icon: string = 'th-large';
export const namespace: string = 'business-intelligence';
export const themeId: string = 'widget-workspace-container';

export const themeFields = {
    makeFiltersLocal: platformThemeConstants.widgetWorkspaceMakeFiltersLocal
};